import styled from "styled-components";
import { MD_SCREEN } from "../util/screen-size";


//Parent
export const getStyledSecionHolder = (size: boolean) => styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: ${size ? '10vh' : ''};
`

export const getStyledSectionWrapper = (margin?: number) => styled.section`
    @media (max-width: ${MD_SCREEN}px) {
        height: 92vh;
        width: 100vw;
        ${margin ? `margin-top: ${margin}vh`: ''}
    }
`

export const getStyledSectionWrapperInset = () => styled.div`
    padding: 0 10vw;
`